module.exports = __webpack_public_path__ + "img/组 5.1e61122a.png";